import { ReactNode } from "react";
import cn from "clsx";

// SectionHeader — die EINE Section-Ueberschrift des DS: 12px, uppercase,
// tracking, text-3. Optionaler rechter Slot (z.B. Sortier-Hinweis).
export interface SectionHeaderProps {
  children: ReactNode;
  right?: ReactNode;
  className?: string;
}

export function SectionHeader({ children, right, className }: SectionHeaderProps) {
  return (
    <div className={cn("mb-2.5 flex items-center gap-2", className)}>
      <span className="text-[0.72rem] font-semibold uppercase tracking-[0.06em] text-text-3">
        {children}
      </span>
      {right && <span className="ml-auto text-[0.7rem] text-text-3 normal-case tracking-normal">{right}</span>}
    </div>
  );
}

export default SectionHeader;
